export const APPLICATION_STEPS = [
  {
    step: 1,
    title: "1. Select Legal Status",
  },
  {
    step: 2,
    title: "2. Complete Application",
  },
  {
    step: 3,
    title: "3. Submit Filing",
  },
];
